import { FETCHING_DATA, FETCHING_DATA_SUCCESS, FETCHING_DATA_FAILURE } from './Globals'
import { put, takeEvery, call } from 'redux-saga/effects'
import getIpa, { checkStatus, parseJSON } from './Client'
import log from 'loglevel';

/* 
 * Sagas to handle calls to backend API
 */

export function* fetchDataSaga (action) {
  log.debug("fetchDataSaga called", action)
  try {
    // call API
    const data = yield call(getIpa, action.word, action.ipaflavour)
    // check return status
    const dataStatus = yield call(checkStatus, data);
    // get JSON from return ...
    const parsedJson = yield call(parseJSON, dataStatus);
    // ... and update Redux store
    yield put({ type: FETCHING_DATA_SUCCESS, ipa: parsedJson.ipa })
  } catch (error) {
  	log.warn('FETCHING_DATA_FAILURE', error.message)
    yield put({ type: FETCHING_DATA_FAILURE, message: error.message })
  }
}

// listen for actions of type FETCHING_DATA and use them
function* dataSaga () {
  yield takeEvery(FETCHING_DATA, fetchDataSaga)
}

export default dataSaga



// WEBPACK FOOTER //
// ./src/sagas.js